<div class="items-page">
  <div class="items-toolbar">
    <div>
      <h4 class="mb-1">Items</h4>
      <div class="items-meta">
        Showing {{ startItem }}-{{ endItem }} of {{ filteredProducts.length }} products
        <span *ngIf="lastSyncDate">Last sync: {{ lastSyncDate | date:'dd.MM.yyyy HH:mm' }}</span>
      </div>
    </div>

    <button type="button"
            class="btn btn-primary btn-sm"
            [disabled]="isSyncing"
            (click)="syncProducts()">
      <span class="fas" [ngClass]="isSyncing ? 'fa-spinner fa-spin' : 'fa-sync-alt'"></span>
      <span class="ml-1">{{ isSyncing ? 'Syncing' : 'Sync' }}</span>
    </button>
  </div>

  <div class="items-filters">
    <input type="text"
           class="form-control form-control-sm"
           placeholder="Search item code, name or group..."
           [(ngModel)]="searchText"
           (ngModelChange)="onFilterChange()" />

    <select class="custom-select custom-select-sm"
            [(ngModel)]="selectedGroupId"
            (change)="onFilterChange()">
      <option value="">All Groups</option>
      <option *ngFor="let group of itemGroups; trackBy: trackByGroup" [value]="group.groupId">
        {{ group.groupName }}
      </option>
    </select>

  </div>

  <div class="items-table-wrap">
    <table class="table table-sm items-table mb-0">
      <thead>
        <tr>
          <th style="width: 64px;">Image</th>
          <th style="width: 130px;">Item Code</th>
          <th>Item Name</th>
          <th style="width: 220px;">Group</th>
          <th style="width: 90px;">Unit</th>
          <th style="width: 110px;" class="text-right">Price</th>
          <th style="width: 150px;">Synced</th>
          <th style="width: 72px;" class="text-center">Sync</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="isLoading">
          <td colspan="8" class="text-center text-muted py-4">
            Loading products...
          </td>
        </tr>

        <tr *ngFor="let p of pagedProducts; trackBy: trackByProduct">
          <td>
            <img class="item-thumb"
                 [src]="p.img || defaultImage"
                 [alt]="p.itemName"
                 (error)="onImageError($event)">
          </td>
          <td class="font-weight-semibold">{{ p.itemCode }}</td>
          <td>{{ p.itemName }}</td>
          <td>{{ p.groupName || '-' }}</td>
          <td>{{ p.itemUnit || '-' }}</td>
          <td class="text-right">{{ p.price | number:'1.2-2' }}</td>
          <td>{{ p.lastSyncDate | date:'dd.MM.yyyy HH:mm' }}</td>
          <td class="text-center">
            <button type="button"
                    class="btn btn-sm btn-falcon-default item-sync-btn"
                    [disabled]="isSyncing || (!!syncingItemCode && syncingItemCode !== p.itemCode)"
                    (click)="syncProduct(p)"
                    title="Sync this item">
              <span class="fas" [ngClass]="syncingItemCode === p.itemCode ? 'fa-spinner fa-spin' : 'fa-sync-alt'"></span>
            </button>
          </td>
        </tr>

        <tr *ngIf="!isLoading && filteredProducts.length === 0">
          <td colspan="8" class="text-center text-muted py-4">
            No items found.
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="items-footer" *ngIf="filteredProducts.length > 0">
    <button class="btn btn-falcon-default btn-sm"
            type="button"
            [disabled]="currentPage === 1"
            (click)="prevPage()">
      <span class="fas fa-chevron-left"></span>
    </button>

    <span class="items-page-text">Page {{ currentPage }} of {{ totalPages }}</span>

    <button class="btn btn-falcon-default btn-sm"
            type="button"
            [disabled]="currentPage === totalPages"
            (click)="nextPage()">
      <span class="fas fa-chevron-right"></span>
    </button>
  </div>
</div>
